export enum ErrorsCode {
  ENTITY_DOES_NOT_EXIST = 1001,
  ENTITY_ALREADY_EXISTS = 1002,
  PERMISSION_DENIED = 1003,
  INVALID_REQUEST = 1004,
  NO_AVAILABILITIES_FOUND = 1005,
  TICKET_CREATION = 1006,
  PAYMENT = 1007,
  MAX_CAPACITY = 1008,
  UNFEASIBLE_BOOKING = 1009,
  INVALID_TRIP_STATUS = 1010,
  DATABASE_CONFLICT = 1011,
  MESSAGE_TYPE_NOT_ENABLED = 1012,
  PASSWORD_REPEATED = 1013,

  // SERVICES
  NO_UNIQUE_PATH = 2001,
  NO_PATH = 2002,
  START_OR_END_MISSING = 2003,
  WRONG_TICKETING_TYPE = 2004,
  STOP_IN_USE = 2005,
  START_OR_END_ON_DYNAMIC = 2006,
  ALTERATION_OVERLAP = 2007,
  EMPTY_WHITE_LIST = 2008,

  // SETUP
  REPEATED_DAY_OF_WEEK = 3001,
  
  // EXCEL IMPORT
  STOP_FAR_FROM_ROAD = 4004,
  STOP_DUPLICATED_ON_PATH = 4005,
  STOP_NOT_ON_SHEET = 4006
}
